/**
 * @ngdoc directive
 * @name elastic
 * @restrict A
 * @require ngModel
 * @description
 * Detect model changes in the element and window resizes,
 * and grow or shrink the element accordingly.
 *
 * Example:
 * <textarea ng-model="$ctrl.text" elastic></textarea>
 *
 * @memberof common
 * @return {Object} The directive properties.
 */
const Elastic = ($window) => {
  'ngInject';

  return {
    restrict: 'A',
    require: 'ngModel',
    link($scope, $element, attrs, ngModel) {
      const element = $element[0];
      const resize = () => {
        const { scrollHeight } = element;
        element.style.height = `${scrollHeight}px`;

        if (scrollHeight === element.scrollHeight) {
          /**
           * We are done resizing, we must normalize the height,
           * since sometimes the scrollHeight is different than
           * the number of lines * lineHeight.
           * @ignore
           */
          const style = $window.getComputedStyle(element);
          const lineHeight = parseInt(style.lineHeight, 10) || 1;
          const paddingTop = parseInt(style.paddingTop, 10) || 0;
          const paddingBottom = parseInt(style.paddingTop, 10) || 0;

          // The inner height is the  scrollHeight minus the paddingTop and paddingBottom
          let times = scrollHeight - paddingTop - paddingBottom;
          // Round up the number of times the lineHeight
          times = Math.ceil(times / lineHeight);

          const height = (times * lineHeight) + paddingTop + paddingBottom;
          element.style.height = `${height}px`;
        } else {
          /**
           * As we resize, the scrollHeight can change to shrink more space,
           * so we must resize again.
           * @ignore
           */
          resize();
        }
      };

      const stopWatch = $scope.$watch(() => (ngModel.$modelValue), resize);
      $window.addEventListener('resize', resize);

      $scope.$on('$destroy', () => {
        stopWatch();
        $window.removeEventListener('resize', resize);
      });
    },
  };
};

export default Elastic;



// WEBPACK FOOTER //
// ./src/frontend/modules/common/directives/elastic.js